export const environment = {
  production: false,
  apiProjectUrl: 'https://a314-projects-qa.oconnell.avwaveinteractive.com/projects',
  apiUrlAdmin: 'https://a314-admin-users-qa.oconnell.avwaveinteractive.com/admin-users',
  apiGoogleStorage: 'https://a314-google-storage-qa.oconnell.avwaveinteractive.com/storage',
  urlStorage: 'https://oconnell-avwave-qa.storage.googleapis.com/',
  testUser: {
    // tslint:disable-line
    token: 'cualquiercosa',
    email: 'user@user.user',
  },
};

